var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#192949",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15.5C10.5 15.7761 10.2761 16 10 16C9.72386 16 9.5 15.7761 9.5 15.5V7.55542C9.22586 7.62431 8.96668 7.75747 8.75062 7.95523L8.72309 7.98102L8.69611 8.00749L6.35382 10.3533C6.1587 10.5487 5.84212 10.5489 5.64671 10.3538C5.4513 10.1587 5.45107 9.84212 5.64618 9.64671L7.99014 7.29925L7.99271 7.29667L7.99272 7.29668L7.99485 7.29458C8.00929 7.28032 8.02 7.26976 8.03105 7.25916C8.04204 7.24862 8.053 7.23842 8.06775 7.22469L8.0679 7.22454L8.0702 7.22241L8.07285 7.21994L8.07286 7.21995C9.13281 6.24719 10.823 6.26172 11.8639 7.25422L14.345 9.6199C14.5449 9.81046 14.5524 10.127 14.3619 10.3268C14.1713 10.5267 13.8548 10.5342 13.655 10.3436L11.1738 7.97796C10.9796 7.79276 10.7477 7.66124 10.5 7.58364V15.5ZM15.5 5C15.7761 5 16 4.77614 16 4.5C16 4.22386 15.7761 4 15.5 4L4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5L15.5 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.7a368cd117c9b4f2379b69fefce9ae0e.svg";
export { ForwardRef as ReactComponent };